import { _Comment_liquid } from "../../@types/shopify";

const initCommentCard = ($el: HTMLElement, $refs: Record<string, HTMLElement>, commentId: string) => {
  const random_id = utils.shortUUID();

  const comment =
    _comments[commentId] ||
    utils.JSONParse<_Comment_liquid>(document.querySelector(`[data-comment-data="${commentId}"]`)?.innerHTML);

  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...(comment ?? {}),
    url: comment?.url,
  });

  const getDynamicValue = (content: string) => {
    return utils.getBracketInputDynamicValue(content, state);
  };

  const getDynamicValueWithFallbacks = (content: string) => {
    return content.split(",")?.reduce((acc, item) => {
      acc ||= utils.getBracketInputDynamicValue(item.trim(), state);
      return acc;
    }, "");
  };

  const getDynamicText = (content: string) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  };

  const getContentLabels = (key: string) => {
    const labels = key.split(".").reduce<any>((acc, selector) => {
      if (!selector || acc === undefined || acc === null) return acc || "";

      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);

    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  };

  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
  };
};

const fallbackHydrationQueue = new Set<HTMLElement>();

const hydrateCommentCardContent = ($el: HTMLElement) => {
  const card_handle = $el.getAttribute(`data-card-handle`);
  const comment_id = $el.getAttribute(`data-comment-id`);
  const classes = utils.JSONParse<string[]>($el.getAttribute(`data-card-classes`) ?? "[]");

  const node = document.querySelector(`[data-comment-card='${card_handle}']`)?.cloneNode(true) as HTMLElement;

  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }

  node?.removeAttribute(`data-comment-card`);
  node?.setAttribute("data-comment-id", comment_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });

  node.classList.add(...classes);
  $el.parentNode?.replaceChild(node, $el);
};

document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateCommentCardContent(el);
  });
  fallbackHydrationQueue.clear();
});

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateCommentCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);

const hydrateCommentCard = ($el: HTMLElement) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateCommentCardContent($el);
    return;
  }

  observer.observe($el);
};

export type InitCommentCard = typeof initCommentCard;
export type HydrateCommentCard = typeof hydrateCommentCard;

window._sections["initCommentCard"] = initCommentCard;
window._sections["hydrateCommentCard"] = hydrateCommentCard;
